module.exports = __webpack_public_path__ + "img/gallery06.ae4a85ec.jpg";